/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAwsCustomLensPillar {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAwsCustomLensPillar.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAwsCustomLensPillar>): WellArchitectedFrameworkAwsCustomLensPillar {
        let obj = Object.assign(new WellArchitectedFrameworkAwsCustomLensPillar(), model);
        WellArchitectedFrameworkAwsCustomLensPillar.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAwsCustomLensPillar>): WellArchitectedFrameworkAwsCustomLensPillar {
        if (!model) return null;
        return WellArchitectedFrameworkAwsCustomLensPillar.newInstance(<WellArchitectedFrameworkAwsCustomLensPillar> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAwsCustomLensPillar) {
        if (!obj) return;

        models.WellArchitectedFrameworkAwsCustomLensPillar.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAwsCustomLensPillar): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAwsCustomLensPillar.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.questions) {
            for (let val of this.questions) {
                models.WellArchitectedFrameworkAwsCustomLensQuestion.fixupPrototype(val);
            }
        }
    }

    /**
     * Id of pillar associated with AWS custom lens
     */
    sys_id: string;

    /**
     * Name of pillar associated with AWS custom lens
     */
    name: string;

    /**
     * Questions associated with AWS custom lens
     */
    questions: Array<models.WellArchitectedFrameworkAwsCustomLensQuestion>;

}
